import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "root" }
const _hoisted_2 = { class: "container-shell" }
const _hoisted_3 = { class: "container-shell-title" }
const _hoisted_4 = {
  id: "container",
  ref: "container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString($setup.videoTitle), 1),
      _createElementVNode("div", _hoisted_4, null, 512)
    ])
  ]))
}